module.exports = __webpack_public_path__ + "static/media/logo.9cba4898.svg";